import {
  SnackbarProvider as InternalSnackbarProvider,
  SnackbarProviderProps,
} from 'notistack'
import style from './index.module.scss'

export { enqueueSnackbar, useSnackbar, SnackbarContent } from 'notistack'

export type { CustomContentProps, EnqueueSnackbar } from 'notistack'

import { Snackbar } from './Snackbar'

export const SnackbarProvider = (props: SnackbarProviderProps) => {
  const { children, ...other } = props
  return (
    <InternalSnackbarProvider
      maxSnack={5}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      Components={{
        warning: Snackbar,
        error: Snackbar,
        info: Snackbar,
        success: Snackbar,
        // @ts-ignore
        default: Snackbar,
      }}
      classes={{ containerRoot: style.root }}
      {...other}
    >
      {children}
    </InternalSnackbarProvider>
  )
}
